import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
  link: {
    textDecoration: 'none',
    '&:hover, &:focus': {
      backgroundColor: theme.palette.background.light,
    },
  },
  linkActive: {
    backgroundColor: theme.palette.background.light,
  },
  linkNested: {
    paddingLeft: theme.spacing(5),
    '&:hover, &:focus': {
      backgroundColor: theme.palette.background.light,
    },
  },
  linkIcon: {
    marginLeft: theme.spacing(0.1),
    color: `${theme.palette.text.secondary}99`,
    transition: theme.transitions.create('color'),
    display: 'flex',
    justifyContent: 'left',
    minWidth: '35px',
  },
  linkIconActive: {
    color: theme.palette.primary.main,
  },
  linkText: {
    padding: 0,
    color: 'black',
    transition: theme.transitions.create(['opacity', 'color']),
    fontSize: 14,
  },
  linkTextActive: {
    color: theme.palette.text.primary,
  },
  linkTextHidden: {
    opacity: 0,
  },
  sectionTitle: {
    marginLeft: theme.spacing(4.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    height: 1,
    backgroundColor: '#D8D8D880',
  },
}))
